import React from 'react';

const fmt = (n) =>
  `₹${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/**
 * Informational commission rows — shown below Amount to Pay for eligible agents.
 * Does NOT change the checkout debit amount.
 */
export default function FareCommissionRows({ commissionFare, className = '' }) {
  if (!commissionFare?.showAgentLines) {
    return null;
  }

  const {
    commissionReceivable = 0,
    tds = 0,
    effectiveCost = 0,
    isEstimate = true,
    nfAvailable = true,
  } = commissionFare;

  return (
    <div className={className} data-testid="fare-commission-rows">
      <div className="border-t border-dashed border-gray-300 my-3 pt-3 space-y-2">
        <div
          className="flex justify-between text-sm"
          data-testid="fare-commission-receivable-row"
        >
          <span className="text-gray-600">
            Commission receivable{isEstimate ? ' (est.)' : ''}
          </span>
          <span className="font-semibold text-emerald-700">+{fmt(commissionReceivable)}</span>
        </div>
        {tds > 0 && (
          <div className="flex justify-between text-sm" data-testid="fare-commission-tds-row">
            <span className="text-gray-600">TDS on commission</span>
            <span className="font-semibold text-gray-700">−{fmt(tds)}</span>
          </div>
        )}
        <div
          className="flex justify-between text-sm pt-1"
          data-testid="fare-effective-cost-row"
        >
          <span className="text-gray-600">Effective cost after commission</span>
          <span className="font-semibold text-[#1B375B]">{fmt(effectiveCost)}</span>
        </div>
        <p className="text-[10px] text-gray-500 leading-snug" data-testid="fare-commission-footnote">
          Full fare is debited at checkout. Commission is credited to your wallet/credit line after
          booking (subject to TDS).
          {!nfAvailable && ' Commission amount may update once confirmed by the airline.'}
        </p>
      </div>
    </div>
  );
}
